<template>
    <!-- Lista con formato de planilla: mismas columnas del Excel + las del CRM (en
         violeta). Encabezado y columna Empresa fijos; Status, Prioridad y Asignada a
         se cambian desde la celda; clic en la fila abre el detalle. -->
    <div class="cr-list">
        <div v-if="!filas.length" class="cr-list-empty">
            <h3>{{ crm.t('list.none_t') }}</h3><p>{{ crm.t('list.none_p') }}</p>
            <button type="button" class="cr-btn cr-btn-ghost" @click="crm.limpiar()">{{ crm.t('f.clear') }}</button>
        </div>
        <template v-else>
            <div ref="wrap" class="cr-xl-wrap">
                <table class="cr-xl" :style="{ width: ancho + 'px' }">
                    <colgroup><col style="width:52px"><col v-for="c in COLS" :key="c.k" :style="{ width: c.w + 'px' }"></colgroup>
                    <thead><tr>
                        <th class="cr-xl-n cr-xl-fix0" scope="col"><span class="cr-sr">{{ crm.t('list.row') }}</span></th>
                        <th v-for="c in COLS" :key="c.k" scope="col" :class="{ 'cr-xl-fix1': c.fijo, 'cr-xl-crm': c.crm }" :aria-sort="orden.k === c.k ? (orden.dir > 0 ? 'ascending' : 'descending') : null">
                            <button type="button" @click="ordenar(c.k)">{{ titulo(c) }}<span v-html="I.sort"></span></button>
                        </th>
                    </tr></thead>
                    <tbody>
                        <tr v-for="(c, i) in filas" :key="c.id" :data-id="c.id" tabindex="0" :class="{ 'is-sel': crm.abiertaId === c.id }" @click="clic(c, $event)" @keydown="tecla(c, $event)">
                            <td class="cr-xl-n cr-xl-fix0">{{ i + 1 }}</td>
                            <td class="cr-xl-fix1"><span class="cr-xl-emp" :title="c.empresa">{{ c.empresa }}</span></td>
                            <td class="cr-xl-c-estado"><button type="button" class="cr-xl-dd" aria-haspopup="listbox" aria-expanded="false" :aria-label="crm.t('p.state') + ': ' + c.empresa" @click.stop="crm.ddTarjeta($event, c, 'estado')"><span v-html="crm.estPill(c.estado)"></span><span class="cr-chev" v-html="I.chev"></span></button></td>
                            <td class="cr-xl-c-prioridad"><button type="button" class="cr-xl-dd" aria-haspopup="listbox" aria-expanded="false" :aria-label="crm.t('p.pri') + ': ' + c.empresa" @click.stop="crm.ddTarjeta($event, c, 'pri')"><span v-html="crm.priPill(c.prioridad)"></span><span class="cr-chev" v-html="I.chev"></span></button></td>
                            <td><span v-if="c.ciudades" class="cr-xl-txt" :title="c.ciudades">{{ c.ciudades }}</span></td>
                            <td><span v-if="c.tipo" class="cr-xl-txt" :title="c.tipo">{{ c.tipo }}</span></td>
                            <td><a v-if="url(c.web)" class="cr-xl-link" :href="url(c.web)" target="_blank" rel="noopener" :title="c.web">{{ dominio(c.web) }}</a></td>
                            <td><a v-if="c.email" class="cr-xl-link" :href="'mailto:' + c.email" :title="c.email">{{ c.email }}</a></td>
                            <td><span v-if="c.contacto" class="cr-xl-txt" :title="c.contacto">{{ c.contacto }}</span></td>
                            <td><span v-if="c.cargo" class="cr-xl-txt" :title="c.cargo">{{ c.cargo }}</span></td>
                            <td><a v-if="url(c.liP)" class="cr-xl-link cr-xl-in" :href="url(c.liP)" target="_blank" rel="noopener" :title="c.liP"><span v-html="I.in"></span>{{ crm.t('list.profile') }}</a></td>
                            <td><a v-if="url(c.liE)" class="cr-xl-link cr-xl-in" :href="url(c.liE)" target="_blank" rel="noopener" :title="c.liE"><span v-html="I.in"></span>{{ crm.t('list.company') }}</a></td>
                            <td class="cr-xl-c-asignado"><button type="button" class="cr-xl-dd" aria-haspopup="listbox" aria-expanded="false" :aria-label="crm.t('p.asig') + ': ' + c.empresa" @click.stop="crm.ddTarjeta($event, c, 'asig')"><span v-html="crm.whoHTML(c.asignado)"></span><span class="cr-chev" v-html="I.chev"></span></button></td>
                            <td><span class="cr-cd-age" :class="crm.edad(c).nivel ? 'is-' + crm.edad(c).nivel : ''" :title="crm.t('p.since', { f: crm.fecha(c.estadoDesde) })"><span v-html="I.clock"></span>{{ crm.edad(c).txt }}</span></td>
                            <td><span class="cr-lt-who" :title="crm.fecha(c.ultimo.t)"><span v-html="crm.avHTML(c.ultimo.q, 'cr-av--s')"></span><span class="cr-xl-txt">{{ crm.nombreDe(c.ultimo.q) }} · {{ crm.rel(c.ultimo.t) }}</span></span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="cr-xl-foot">{{ crm.tc('list.foot', filas.length) }}</p>
        </template>
    </div>
</template>

<script>
import { I, norm, urlOk, dominio, PRI_ORDEN } from './crmUtil';

// Mismo orden de columnas que el Excel, con Status y Prioridad después de Empresa.
const COLS = [
    { k: 'empresa', w: 230, fijo: true, xl: 'Empresa' }, { k: 'estado', w: 200, xl: 'Status' }, { k: 'prioridad', w: 132, xl: 'Prioridad' },
    { k: 'ciudades', w: 230, xl: 'Ciudades' }, { k: 'tipo', w: 260, xl: 'Tipo de operador' }, { k: 'web', w: 190, xl: 'Web' }, { k: 'email', w: 240, xl: 'Email' },
    { k: 'contacto', w: 190, xl: 'Nombre contacto' }, { k: 'cargo', w: 200, xl: 'Cargo' }, { k: 'liP', w: 150, xl: 'LinkedIn personal' }, { k: 'liE', w: 150, xl: 'LinkedIn empresa' },
    { k: 'asignado', w: 170, crm: true }, { k: 'edad', w: 124, crm: true }, { k: 'ultimo', w: 220, crm: true },
];

export default {
    name: 'CrmList',
    inject: ['crm'],
    data() { return { I, COLS, orden: { k: 'ultimo', dir: -1 } }; },
    computed: {
        ancho() { return 52 + COLS.reduce((s, c) => s + c.w, 0); },
        filas() {
            const { k, dir } = this.orden;
            const val = c => {
                if (k === 'estado') return this.crm.estado(c.estado).o;
                if (k === 'prioridad') return PRI_ORDEN[c.prioridad] || 4;
                if (k === 'asignado') return c.asignado ? norm(this.crm.nombreDe(c.asignado)) : '~';
                if (k === 'edad') return -c.estadoDesde;
                if (k === 'ultimo') return c.ultimo.t;
                return norm(c[k]) || '~';
            };
            return this.crm.visibles.slice().sort((a, b) => { const x = val(a), y = val(b); return (x > y ? 1 : x < y ? -1 : a.id - b.id) * dir; });
        },
    },
    methods: {
        url: urlOk, dominio,
        titulo(c) { return c.crm ? this.crm.t('list.col.' + c.k) : c.xl; },
        ordenar(k) { this.orden = this.orden.k === k ? { k, dir: -this.orden.dir } : { k, dir: k === 'ultimo' || k === 'edad' ? -1 : 1 }; },
        clic(c, e) { if (!e.target.closest('a, button')) this.crm.abrir(c.id); },
        tecla(c, e) {
            if (e.target !== e.currentTarget) return;
            if (e.key === 'Enter') this.crm.abrir(c.id);
            else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();
                const n = e.key === 'ArrowDown' ? e.currentTarget.nextElementSibling : e.currentTarget.previousElementSibling;
                if (n) n.focus();
            }
        },
        marcar(id) {
            this.$nextTick(() => { const tr = this.$el.querySelector && this.$el.querySelector(`tr[data-id="${id}"]`); if (tr) tr.scrollIntoView({ block: 'nearest' }); });
        },
    },
};
</script>
